import { useTranslation } from "react-i18next";
import React from 'react';
import { Select, Spin } from 'antd';
import { useRecipients } from '../hooks/useRecipients';

const { Option, OptGroup } = Select;

interface RecipientOption {
  id: string;
  name: string;
  role: string;
}

interface GroupOption {
  id: string;
  label: string;
  role: string;
}
interface Props {
  value?: string[];
  onChange?: (value: string[]) => void;
  predefinedGroups?: GroupOption[];
}

const RecipientDropDown: React.FC<Props> = ({ value, onChange, predefinedGroups = [] }) => {
  const { recipients, loading, setQuery } = useRecipients();
  const { t } = useTranslation();

  // Format dynamic recipients
  const userOptions: RecipientOption[] = recipients.map(r => ({
    id: r.id,
    name: `${r.name} (${r.email} - ${t(r.role)})`,
    role: r.role,
  }));

  return (
    <Select
      mode="multiple"
      showSearch
      placeholder={t("search_recipients")}
      value={value}
      onChange={onChange}
      onSearch={setQuery}
      notFoundContent={loading ? <Spin size="small" /> : t("no_recipents_found")}
      filterOption={false}
      tagRender={({ label }) => (
        <span className="badge bg-outline-primary">{label}</span>
      )}
      style={{ width: '100%' }}
    >
      {predefinedGroups.length > 0 && (
        <OptGroup label={t("groups")}>
          {predefinedGroups.map(group => (
            <Option key={group.id} value={group.id} label={group.label}>
               {t(group.label)}
            </Option>
          ))}
        </OptGroup>
      )}

      <OptGroup label={t("individuals")}>
        {userOptions.map(recipient => (
          <Option key={recipient.id} value={recipient.id} label={recipient.name}>
            {recipient.name}
          </Option>
        ))}
      </OptGroup>
    </Select>
  );
};

export default RecipientDropDown;
